<script setup lang="ts">
    import { CardTitle } from '@/components/ui/card';
    import { columns } from '@/tables/columns/employee-optionals';
    import { Head } from '@inertiajs/vue3';
    import { useQuery } from '@tanstack/vue-query';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import DataTable from '@/components/datatable/DataTable.vue';
    import PageCard from '@/components/PageCard.vue';
    import QueryKey from '@/enums/QueryKey';
    import type { BreadcrumbItem } from '@/types';
    import Permission from '@/enums/Permission';
    import { usePermissions } from '@/composables/usePermissions';

    const { hasPermission } = usePermissions();

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'dashboards.payroll',
        },
        {
            title: 'employees-optionals.page_header',
        },
    ];

    const { isPending, isFetching, isError, data, error, refetch } = useQuery({
        queryKey: [QueryKey.EMPLOYEE_OPTIONALS],
        queryFn: getEmployeeOptionals,
    });

    async function getEmployeeOptionals() {
        const { data } = await axios.get(route('v2.salary.employees-optionals.table'));
        return data.data;
    }
</script>

<template>
    <Head :title="$t('employees-optionals.page_header')" />

    <AppLayout :breadcrumbs="breadcrumbs">
        <PageCard v-if="hasPermission(Permission.SALARY_COMPANY_VIEW)">
            <DataTable
                :table-key="QueryKey.EMPLOYEE_OPTIONALS"
                :columns="columns"
                :data="data"
                :loading="isPending"
                :default-sorting="[
                    {
                        id: 'name',
                        desc: false,
                    },
                ]"
            >
                <template #title>
                    <CardTitle>
                        {{ $t('employees-optionals.page_header') }}
                    </CardTitle>
                </template>
            </DataTable>
        </PageCard>
    </AppLayout>
</template>
